
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.333.667h-7c-2.566 0-4.666 1.866-4.666 4.148C2.1 4.815 0 6.68 0 8.963v6.222c0 2.282 2.1 4.148 4.667 4.148h7c2.566 0 4.666-1.866 4.666-4.148C18.9 15.185 21 13.32 21 11.037V4.815C21 2.533 18.9.667 16.333.667zM14 15.185c0 1.141-1.05 2.074-2.333 2.074h-7c-1.284 0-2.334-.933-2.334-2.074V8.963c0-1.14 1.05-2.074 2.334-2.074h7c1.283 0 2.333.933 2.333 2.074v6.222zm4.667-4.148c0 1.14-1.05 2.074-2.334 2.074V8.963c0-2.282-2.1-4.148-4.666-4.148H7C7 3.674 8.05 2.74 9.333 2.74h7c1.284 0 2.334.933 2.334 2.074v6.222z","fill":"var(--legend-c-text)"}})])
          )
        }
      }
    